import React, { useState } from "react";

import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Constants from "../../../utils/Constants";
import SplashScreen from "../../../components/loader/SplashScreen/SplashScreen";
import { useEffect } from "react";
import SearchHead from "../../../components/custom/SearchHead";
import ReactPaginate from "react-paginate";
import UIkit from "uikit";
import EditCustomer from "../modals/EditCustomer";
import { usePermissions } from "../../../context/PermissionsContext";

const Cust = () => {
  const [page, setPage] = useState(1);
  const [loader, Setloader] = useState(false);
  const [searchparam, setsearchparam] = useState(null);
  const [customerDetails, setcustomerDetails] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const {Permissions} = usePermissions();

  const CustomersApi = (page) => {
    return axios({
      method: "get",
      params: {
        page: page || 1,
        limit: 100,
        // if search Param is null it wont be included in param 
        ...(searchparam ? { search: searchparam } : {}),
        ...(startDate ? { 'createdAt[gte]': startDate } : {}),
        ...(endDate ? { 'createdAt[lte]': endDate } : {}),
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: Constants.url + "customers",
    }).then((res) => {
      return res.data.data;
    });
  };

  const {
    data: Customersdata,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => CustomersApi(page),
    queryKey: ["Custdata", page],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  useEffect(() => {
    refetch()
  } , [searchparam , startDate , endDate])

  const headers = [
    { label: "S.NO", key: "" },
    { label: "Full Name", key: "fullname" },
    { label: "Email", key: "email" },
    { label: "Type", key: "type" },
    { label: "Phone", key: "phone" },
    { label: "City", key: "city" },
    { label: "Created At", key: "createdAt" },
  ];

  const Refresh = () => {
    Setloader(true);
    refetch().then(() => {
      Setloader(false);
    });
  };

  return (
    <>

      {/* Single Customer Details Edit Modal */}
      <div id="editCustomerModal" uk-modal="" container="#pageId">
        <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover" style={{ width: '800px', marginTop: '20px' }}>
          <button className="uk-modal-close-default" type="button" uk-close="" onClick={() => setcustomerDetails(null)}>
            
          </button>

          <h3 className="uk-text-bold uk-text-light uk-text-center">
            Edit Customer Details
          </h3>
          {customerDetails && <EditCustomer key={customerDetails._id} customerDetails={customerDetails} refetch={refetch} />}
        </div>
      </div>

      {!isLoading && !loader ? (
        <div className="uk-grid" uk-grid="">
          <div className="uk-width-1-1">
            <SearchHead
              searchparam={searchparam}
              RefreshFunc={Refresh}
              headers={headers}
              CsvData={Customersdata.customers}
              Filename={"customers_data.csv"}
              setsearchparam={setsearchparam}
              endpoint="customers"
              startDate={startDate}
              endDate={endDate}
              setStartdate={setStartDate}
              setEndDate={setEndDate}
            />

            <div className="analyticsTableWrp uk-overflow-auto ">
              <table className="uk-table uk-table-striped ">
                <thead className="table-header-shadow">
                  <tr>
                    {headers.map((head) => (
                      <th key={head}> {head.label}</th>
                    ))}

                    {/* white space character */}
                    <th>​</th>
                  </tr>
                </thead>
                <tbody>
                  {Customersdata.customers.map((cust, index) => (
                    <tr key={index}>
                      <>
                        <td>{(page - 1) * 100 + (index + 1)}</td>
                        <td>{cust.fullname || "-"}</td>
                        {/* <td>{cust.lastName || "-"}</td> */}
                        <td>{cust.email || "-"}</td>
                        <td>{cust.type || "-"}</td>
                        <td>{cust.phone || "-"}</td>
                        <td>{cust.city || "-"}</td>
                        <td>
                          {cust.createdAt
                            ? new Date(cust.createdAt).toLocaleString("en-US", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                            : "-"}
                        </td>

                        <td>
                          {Permissions?.includes("customers-edit") && (
                          <button
                            className="uk-button uk-button-link"
                            onClick={() => {
                              setcustomerDetails(cust )  ;
                              UIkit.modal('#editCustomerModal').show();
                            }}
                          >
                            Edit
                          </button>
                          )}
                        </td>
                      </>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className=" paginationcard uk-card uk-card-default uk-margin-remove-top">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.round(Customersdata.totalRecords / 100)}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => setPage(e.selected + 1)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default Cust;
